export default "__VITE_ASSET__HdqqMPz5__"